import _ from 'lodash'
import * as React from 'react'
import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'
import { setBoxHeight, updateFilterListByID } from '../../redux/slices/Search/input'
import { infoOptions } from '../../utils'
import AutoCompleteItem from '../Autocomplete'
import Container from './Container'

const AutocompleteFilter = ({
  boxGrew,
  type,
  filterList1,
  options,
  boxHeight,
  toFilter,
  children,
  WIDTHMIN,
  w,
  ...rest
}) => {
  const dispatch = useDispatch()
  const autocompleteRef = React.useRef()
  const placeholder = infoOptions?.[type]?.name

  const handleSelection = (e, newList) => {
    const someValue = { ...toFilter, filterList1: newList }
    dispatch(updateFilterListByID({ someId: rest.idx, someValue }))
  }

  // Change height component Autocomplete
  React.useEffect(() => {
    if (type === 'sitetype') return
    if (!Boolean(filterList1.length) && boxHeight !== 40)
      dispatch(setBoxHeight({ someId: rest.idx, someValue: 40 }))
    if (!Boolean(autocompleteRef?.current)) return
    const updateHeight = () =>
      dispatch(
        setBoxHeight({
          someId: rest.idx,
          someValue: autocompleteRef?.current?.clientHeight,
        })
      )
    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => {
      window.removeEventListener('resize', updateHeight)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterList1])

  return (
    <Container w={w} isRow={rest.windowWidth > WIDTHMIN}>
      <Box
        flexGrow={1}
        sx={{
          width: !Boolean(filterList1.length) ? '230px' : '100%',
          maxWidth: rest.windowWidth <= WIDTHMIN ? '100%' : 'calc(100% - 36px)',
        }}>
        <AutoCompleteItem
          type={type}
          options={options}
          autoRef={autocompleteRef}
          valueList={filterList1}
          onChange={handleSelection}
          placeholder={placeholder}
          multiple={!_.includes(['sitetype'], type)}
        />
      </Box>
      {children}
    </Container>
  )
}

export default AutocompleteFilter
